import { defineStore } from 'pinia';

export const useChapterStore = defineStore('chapter', {
    state: () => ({
        id: null,
        novel_id :null
    }),
    actions: {
        setCurrentChapter(id, novel_id) {
            this.id = id;
            this.novel_id = novel_id;
        }
    },
    getters: {
        currentChapter: (state) => ({
            id: state.id,
            novel_id: state.novel_id
        })
    }
});